import {getCurrentHub, startTransaction} from "@sentry/react";
import {Transaction} from "@sentry/types";

export function startSentryTransaction(transactionName: string): Transaction {
    const transaction = startTransaction({name: transactionName});
    const hub = getCurrentHub();
    hub.configureScope((scope) => scope.setSpan(transaction));
    return transaction;
}
